import { Injectable, isDevMode } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http"; // Import it up here
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { catchError } from "rxjs/operators";
import { environment } from "../environments/environment";
import { SessionStorageService } from "./session-storge.service";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private SECRET_KEY = environment.secretKey;
  apiURl = "";
  hextozcc = "hextozcc/";
  zcctohex = "zcctohex/";
  batchhextozcc = "batchhextozcc";
  hueHarmonyVariation = "generateHueVariation";
  splitTonalVariation = "generateSplitTonalVariation";
  saturationVariation = "generateSaturationVariations";
  batchhextocomparezcc = "batchhextocomparezcc";
  loginUrl = "login";
  zccsatchesforLlyer = "zccSwatchesForLayer";
  zacsatchesforLlyer = "zacSwatchesForLayer";
  zacBucket = "bucketsForZAC";
  deltaEBetweenHex = "findDeltaEBetweenHex";
  deltaEBetweenZac = "findDeltaEBetweenTwoZac";
  fileExportUrl = "fileexport";
  batchExportUrl = "batchconversions";
  stringExportUrl = "stringconversions";
  batchFileExportUrl = "batchfileconversions";
  uploadFileUrl = "uploadimage";
  uploadCompareFileUrl = "uploadcompareimage";
  uploadCompareFileUrlBase = "uploadcompareimagebase";
  createManagerReportURL = "createmanagerreport";
  rgbtodeltaeURL = "rgbtodeltae";
  rgbtohexURL = "rgbtohex";
  token: any;
  packageId: any;

  constructor(
    private http: HttpClient,
    private sessionStorageService: SessionStorageService
  ) {
    this.apiURl = environment.apiURl;
    let sessionData: any;
    sessionData = sessionStorageService.getItem("USER_DETAILS");
    if (sessionData) {
      sessionData = JSON.parse(sessionData);
      this.token = sessionData.Token;
      this.packageId = sessionData.PackageId;
    }
  }

  decryptData(encryptedText): any {
    if (!encryptedText) return;
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedText, this.SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedData);
    } catch (error) {
      console.error("Decryption error:", error);
      return null;
    }
  }

  encryptData(data: any): string {
    try {
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        this.SECRET_KEY
      ).toString();
      return encryptedData;
    } catch (e) {
      console.error("Encryption error:", e);
      return null;
    }
  }

  login(username, password) {
    const httpBody = new HttpParams()
      .set("username", username)
      .set("password", password);
    return this.http.post(this.apiURl + this.loginUrl, httpBody);
  }
  hexToZcc(hex) {
    let getUrl = this.apiURl + this.hextozcc + hex;
    return this.http.get(getUrl, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  hexToZccWithCF(hex, cf, l, c) {
    const httpBody = new HttpParams()
      .set("hexString", hex)
      .set("cf", cf)
      .set("l", l)
      .set("c", c);
    let getUrl = this.apiURl + this.hextozcc;
    return this.http.post(getUrl, httpBody, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }
  batchhextoZcc(hex, cf, l, c) {
    const httpBody = new HttpParams()
      .set("hexString", hex)
      .set("cf", cf)
      .set("l", l)
      .set("c", c);
    return this.http.post(this.apiURl + this.batchhextozcc, httpBody, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  generateSaturationVariations(length, changeHue, low, initalHex) {
    const httpBody = new HttpParams()
      .set("length", length)
      .set("changeHue", changeHue)
      .set("low", low)
      .set("initialHex", initalHex);

    return this.http.post(this.apiURl + this.saturationVariation, httpBody, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }
  generateSplitTonalVariation(length, initalHex) {
    const httpBody = new HttpParams()
      .set("length", length)
      .set("initialHex", initalHex);

    return this.http.post(this.apiURl + this.splitTonalVariation, httpBody, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  generateHueVariation(hueAngle, initialHex) {
    const httpBody = new HttpParams()
      .set("hueAngles", hueAngle)
      .set("initialHex", initialHex);

    return this.http.post(this.apiURl + this.hueHarmonyVariation, httpBody, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  batchhextoCompareZcc(hex, ssHex, cf, l, c) {
    const httpBody = new HttpParams()
      .set("hexString", hex)
      .set("selectedSwatchHex", ssHex)
      .set("cf", cf)
      .set("l", l)
      .set("c", c);
    return this.http.post(this.apiURl + this.batchhextocomparezcc, httpBody, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }
  zccSwatchesForLayer(layer) {
    const httpBody = new HttpParams().set("layerName", layer);
    return this.http.post(this.apiURl + this.zccsatchesforLlyer, httpBody, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  zacSwatchesForLayer(layer, zacType = "17") {
    console.log("yera");
    const httpBody = new HttpParams()
      .set("layerName", layer)
      .set("zacType", zacType);
    return this.http.post(this.apiURl + this.zacsatchesforLlyer, httpBody, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  bucketsForZAC(zac, isDeltaE, zacType = "17", { zcc, hex, rgb }) {
    let bodyParam = { zac, isDeltaE, zacType, zcc, hex, rgb };
    return this.http.post(this.apiURl + this.zacBucket, bodyParam, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  zccToHex(zcc) {
    let getUrl = this.apiURl + this.zcctohex + zcc;
    return this.http.get(getUrl, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  findDeltaEBetweenHex(hex1, hex2) {
    let bodyParam = { hex1, hex2 };
    return this.http.post(this.apiURl + this.deltaEBetweenHex, bodyParam, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  findDeltaEBetweenTwoZac(zac1, zac2) {
    let bodyParam = { zac1, zac2 };
    return this.http.post(this.apiURl + this.deltaEBetweenZac, bodyParam, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  downloadFile(fileExchange, outputSwatches) {
    let headers = new HttpHeaders().set("token", this.token);

    const httpBody = new HttpParams()
      .set("fileFormat", fileExchange.fileFormat)
      .set("notes", fileExchange.notes)
      .set("swatchFileName", fileExchange.swatchFileName)
      .set("userName", fileExchange.userName)
      .set("company", fileExchange.company)
      .set("date", fileExchange.date)
      .set("techPack", fileExchange.techPack)
      .set("swatches", JSON.stringify(outputSwatches));
    return this.http
      .post(this.apiURl + this.fileExportUrl, httpBody, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res) => {
          let data = {
            image: new Blob([res.body], {
              type: res.headers.get("Content-Type"),
            }),
            filename: res.headers.get("File-Name"),
          };
          return data;
        })
      );
  }

  exportBatch({ batchData, fileType, conversionType = "zcc" }) {
    let headers = new HttpHeaders().set("token", this.token);
    const httpBody = new HttpParams()
      .set("rawJson", JSON.stringify(batchData))
      .set("conversionType", conversionType)
      .set("fileType", fileType);

    return this.http
      .post(this.apiURl + this.batchExportUrl, httpBody, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res) => {
          var filename = res.headers.get("Content-Disposition");
          let data = {
            image: new Blob([res.body], {
              type: res.headers.get("Content-Type"),
            }),
            filename: filename.split("filename=").pop(),
          };
          return data;
        })
      );
  }

  exportString(string, fileType) {
    let headers = new HttpHeaders().set("token", this.token);
    const httpBody = new HttpParams()
      .set("string", string)
      .set("fileType", fileType);

    return this.http
      .post(this.apiURl + this.stringExportUrl, httpBody, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res) => {
          var filename = res.headers.get("Content-Disposition");
          let data = {
            image: new Blob([res.body], {
              type: res.headers.get("Content-Type"),
            }),
            filename: filename.split("filename=").pop(),
          };
          return data;
        })
      );
  }

  rgbtodeltae(csv) {
    let headers = new HttpHeaders().set("token", this.token);
    const httpBody = new HttpParams().set("csv", csv);

    return this.http
      .post(this.apiURl + this.rgbtodeltaeURL, httpBody, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res) => {
          var filename = res.headers.get("Content-Disposition");
          let data = {
            image: new Blob([res.body], {
              type: res.headers.get("Content-Type"),
            }),
            filename: filename.split("filename=").pop(),
          };
          return data;
        })
      );
  }

  rgbtohex(csv) {
    let headers = new HttpHeaders().set("token", this.token);
    const httpBody = new HttpParams().set("csv", csv);

    return this.http
      .post(this.apiURl + this.rgbtohexURL, httpBody, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res) => {
          var filename = res.headers.get("Content-Disposition");
          let data = {
            image: new Blob([res.body], {
              type: res.headers.get("Content-Type"),
            }),
            filename: filename.split("filename=").pop(),
          };
          return data;
        })
      );
  }

  exportBatchFile(batchData) {
    let headers = new HttpHeaders().set("token", this.token);
    return this.http
      .post(this.apiURl + this.batchFileExportUrl, batchData, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res) => {
          var filename = res.headers.get("Content-Disposition");
          let data = {
            image: new Blob([res.body], {
              type: res.headers.get("Content-Type"),
            }),
            filename: filename.split("filename=").pop(),
          };
          return data;
        })
      );
  }

  uploadFile(batchData) {
    return this.http.post(this.apiURl + this.uploadFileUrl, batchData, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }

  private getTokenHeader() {
    let headers = new HttpHeaders({
      token: this.token,
    });
    return { headers: headers };
  }

  uploadCompareFile(batchData) {
    return this.http.post(this.apiURl + this.uploadCompareFileUrl, batchData, {
      ...this.getTokenHeader(),
      responseType: "text",
    });
  }
  uploadCompareFileAsBase64(imageBase) {
    const httpBody = new HttpParams().set("imagebase", imageBase);
    return this.http.post(
      this.apiURl + this.uploadCompareFileUrlBase,
      httpBody,
      {
        ...this.getTokenHeader(),
        responseType: "text",
      }
    );
  }

  createManagerReport(
    filepath,
    filename,
    techpack,
    notes,
    userName,
    company,
    outputdate,
    swatches
  ) {
    let headers = new HttpHeaders().set("token", this.token);

    const httpBody = new HttpParams()
      .set("filepath", filepath)
      .set("swatches", JSON.stringify(swatches))
      .set("techpack", techpack)
      .set("notes", notes)
      .set("filename", filename)
      .set("userName", userName)
      .set("company", company)
      .set("date", outputdate);

    return this.http
      .post(this.apiURl + this.createManagerReportURL, httpBody, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        map((res) => {
          var filename = res.headers.get("Content-Disposition");
          let data = {
            image: new Blob([res.body], {
              type: res.headers.get("Content-Type"),
            }),
          };
          return data;
        })
      );
  }
}
